import { render, staticRenderFns } from "./PointersOfMonthAdd.vue?vue&type=template&id=28e955a2&scoped=true"
import script from "./PointersOfMonthAdd.vue?vue&type=script&lang=js"
export * from "./PointersOfMonthAdd.vue?vue&type=script&lang=js"
import style0 from "./PointersOfMonthAdd.vue?vue&type=style&index=0&id=28e955a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e955a2",
  null
  
)

export default component.exports